module.exports = __webpack_public_path__ + "img/kerstin.1e165d66.png";